"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;

var _base = babelHelpers.interopRequireDefault(require("modals/base"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _carousel = babelHelpers.interopRequireDefault(require("carousel"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var UpsellModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(UpsellModal, _Modal);

  function UpsellModal(upsellItems) {
    var _this;

    babelHelpers.classCallCheck(this, UpsellModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(UpsellModal).call(this, 'upsell'));
    _this.innerWrapper = false;
    _this.hasModalTitleElement = false;
    _this.upsellItems = upsellItems;
    return _this;
  }

  babelHelpers.createClass(UpsellModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(UpsellModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        var carousel;
        $(element).find('.modal').on('shown.bs.modal', function (event) {
          carousel = _carousel.default.setup(element.querySelector('.card-container'));
        }).on('hidden.bs.modal', function (event) {
          carousel.remove();
          $(element).remove();
        });
        return element;
      });
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "\n\t\t\t<div class=\"upsell-content\">\n\t\t\t\t<h1>Purchasing Options</h1>\n\t\t\t\t<div class='card-container card-grid'>\n\t\t\t\t\t".concat(this.upsellItems.map(function (item) {
        return item.tile;
      }).join(""), "\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t");
    }
  }]);
  return UpsellModal;
}(_base.default);

function show(upsellItems) {
  return new _promisePolyfill.default(function (resolve) {
    var modal = new UpsellModal(upsellItems);
    modal.show().then(function (element) {
      element.querySelectorAll('.buy-button').forEach(function (button) {
        button.addEventListener('click', function (event) {
          var item = upsellItems.filter(function (item) {
            return item.id == button.dataset.target;
          }).shift();
          var price = item.pricingOptions.filter(function (item) {
            return item.type == button.dataset.price;
          }).shift();
          resolve({
            item: item,
            price: price
          });
          modal.hide();
          event.preventDefault();
        });
      });
    });
  });
}